export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILURE = "REGISTER_FAILURE";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const REQUEST_OTP_REQUEST = "REQUEST_OTP_REQUEST";
export const REQUEST_OTP_SUCCESS = "REQUEST_OTP_SUCCESS";
export const REQUEST_OTP_FAILURE = "REQUEST_OTP_FAILURE";

export const VERIFY_OTP_REQUEST = "VERIFY_OTP_REQUEST";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAILURE = "VERIFY_OTP_FAILURE";

export const MOBILE_OTP_REQUEST = "MOBILE_OTP_REQUEST";
export const MOBILE_OTP_SUCCESS = "MOBILE_OTP_SUCCESS";
export const MOBILE_OTP_FAILURE = "MOBILE_OTP_FAILURE";

export const VERIFY_MOBILE_OTP_REQUEST = "VERIFY_MOBILE_OTP_REQUEST";
export const VERIFY_MOBILE_OTP_SUCCESS = "VERIFY_MOBILE_OTP_SUCCESS";
export const VERIFY_MOBILE_OTP_FAILURE = "VERIFY_MOBILE_OTP_FAILURE";

export const RESEND_OTP_REQUEST = "RESEND_OTP_REQUEST";
export const RESEND_OTP_SUCCESS = "RESENDT_OTP_SUCCESS";
export const RESEND_OTP_FAILURE = "RESEND_OTP_FAILURE";

export const UPDATE_PASSWORD_REQUEST = "UPDATE_PASSWORD_REQUEST";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAILURE = "UPDATE_PASSWORD_FAILURE";

export const ADMIN_ADD_REQUEST = "ADMIN_ADD_REQUEST";
export const ADMIN_ADD_SUCCESS = "ADMIN_ADD_SUCCESS";
export const ADMIN_ADD_FAILURE = "ADMIN_ADD_FAILURE";

export const ADMIN_EDIT_REQUEST = "ADMIN_EDIT_REQUEST";
export const ADMIN_EDIT_SUCCESS = "ADMIN_EDIT_SUCCESS";
export const ADMIN_EDIT_FAILURE = "ADMIN_EDIT_FAILURE";

export const ADMIN_VIEW_REQUEST = "ADMIN_VIEW_REQUEST";
export const ADMIN_VIEW_SUCCESS = "ADMIN_VIEW_SUCCESS";
export const ADMIN_VIEW_FAILURE = "ADMIN_VIEW_FAILURE";

export const ADMIN_DELETE_REQUEST = "ADMIN_DELETE_REQUEST";
export const ADMIN_DELETE_SUCCESS = "ADMIN_DELETE__SUCCESS";
export const ADMIN_DELETE_FAILURE = "ADMIN_DELETE__FAILURE";

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

export const REFRESH_TOKEN_REQUEST = "REFRESH_TOKEN_REQUEST";
export const REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS";
export const REFRESH_TOKEN_FAILURE = "REFRESH_TOKEN_FAILURE";

export const RESET_REFRESH_TOKEN_STATE = "RESET_REFRESH_TOKEN_STATE";

export const AUTH_RESET_STATE = "AUTH_RESET_STATE";

export const LOGOUT = "LOGOUT";
export const REDIRECT = "REDIRECT";
